<tt-page>
    <tt-list *ngIf="'mobile' | mediaQuery" class="col-xs-12 sp-0" [ttData]="itemsListReports"></tt-list>

    <tt-divider *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery" ttRememberId="selectreport_dividers">
        <tt-divider-columns>
            <tt-divider-pane ttSize="30">
                <tt-list class="col-xs-12 sp-0" [ttData]="itemsListReports"></tt-list>
            </tt-divider-pane>

            <tt-divider-pane ttSize="70">

            </tt-divider-pane>
        </tt-divider-columns>
    </tt-divider>
</tt-page>
